import { connect } from 'react-redux'
import { isOffline } from 'redux-offline-status'

import Chat from './Chat'

import { getFromSettings, isAfterHours } from 'src/utils/helpers'
import { setChatData, updateChatSessionState, updateStaffMembers } from './actions'
import { setAppActionsDisabledState } from 'src/modules/App/nonPersistentActions'

const mapDispatchToProps = {
  setChatData,
  updateChatSessionState,
  setAppActionsDisabledState,
  updateStaffMembers,
}

const mapStateToProps = state => {
  const afterHours = getFromSettings(state, 'afterHours')
  const timeZone = parseFloat(getFromSettings(state, 'timeZone', 0))

  return {
    // This is not used in Chat component but it should be passed to keep re-rendering working
    // isAppRendered: state.nonPersistentAppReducer.isAppRendered,
    staffMembers: state.chat.staffMembers,
    headerMessage: state.chat.headerMessage,
    isOffline: isOffline(state),
    user: state.user.user,
    sendingData: state.appReducer.sendingData,
    brand: getFromSettings(state, 'brand', {}),
    isAfterHours: isAfterHours(afterHours, timeZone),
    isChatOnlyFeature: state.appReducer.isChatOnlyFeature,
    featureFlags: getFromSettings(state, 'featureFlags', []),
    features: state.appReducer.features,
    chat: state.appReducer.chat,
    chatOptions: getFromSettings(state, 'chatOptions', {}),
    isChatEmpty: state.chat.isChatEmpty,
    isWidgetState: state.appReducer.isWidget,
    newChatAssignee: state.chat.newChatAssignee,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Chat)
